<div class="modal-wrapper">
  <div #modalHeader cf-modal-header [heading]="windowTitle" [hideCloseButton]="false">{{ windowTitle }}</div>
  <div class="modal-body pb-0">
    <ng-container *ngTemplateOutlet="currentTemplate"></ng-container>
  </div>
  <div class="mt-3" *ngIf="submitButton">
    <cf-button (click)="modalHeader.activeModal.close()" class="w-100" size="lg">
      {{ "dropdown.buttons.done" | translate }}
    </cf-button>
  </div>
</div>
